import * as React from "react";
import { observer } from "mobx-react";

import { UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { UitkHeading } from "uitk-react-text";

import { useLocalization } from "@shared-ui/localization-context";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import { Dates } from "components/shared/Dates/Dates";
import { Location } from "components/shared/Location/Location";

import { locKeys } from "../l10n";
import { StaySomewhereElse } from "./StaySomewhereElse";

export const PackageOnewayFlight = observer(({ packageWizardState, setInputsRefs }: PackageSubLOBProps) => {
  const { formatText } = useLocalization();

  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };
  const datesColSpanOneway: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const fssseColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const datesHotelColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };

  const { isFlightHotelOneWayFormValid, updateInvalidFormsState } = packageWizardState;

  if (isFlightHotelOneWayFormValid) {
    updateInvalidFormsState();
  }

  const renderPartialDates = ({ stackedDates = false }: { stackedDates?: boolean }) => (
    <Dates
      lobState={packageWizardState}
      isPartialStay={true}
      colSpan={datesHotelColSpan}
      stackedDates={stackedDates}
      setInputsRefs={setInputsRefs}
    />
  );

  return (
    <>
      <Location
        originField={true}
        destinationField={true}
        showSwapLocationsControl={true}
        lobState={packageWizardState}
        colSpan={locationColSpan}
        onewayFlight={true}
      />
      <Dates
        lobState={packageWizardState}
        colSpan={datesColSpanOneway}
        singleDate={true}
        setInputsRefs={setInputsRefs}
      />

      <UitkLayoutGridItem colSpan="all">
        <UitkHeading level={2} size={600}>
          {formatText(locKeys.hotelSectionLabel)}
        </UitkHeading>
      </UitkLayoutGridItem>

      <StaySomewhereElse lobState={packageWizardState} colSpan={fssseColSpan} />

      <Viewport>
        <ViewSmall>{renderPartialDates({ stackedDates: true })}</ViewSmall>
        <ViewMedium>{renderPartialDates({})}</ViewMedium>
      </Viewport>
    </>
  );
});
